import { render, staticRenderFns } from "./ToolTips.vue?vue&type=template&id=1a534a99&scoped=true"
import script from "./ToolTips.vue?vue&type=script&lang=js"
export * from "./ToolTips.vue?vue&type=script&lang=js"
import style0 from "./ToolTips.vue?vue&type=style&index=0&id=1a534a99&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a534a99",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a534a99')) {
      api.createRecord('1a534a99', component.options)
    } else {
      api.reload('1a534a99', component.options)
    }
    module.hot.accept("./ToolTips.vue?vue&type=template&id=1a534a99&scoped=true", function () {
      api.rerender('1a534a99', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/newMenu/components/ToolTips.vue"
export default component.exports